import { render, staticRenderFns } from "./ModalWidgetClone.vue?vue&type=template&id=c8fc797e&scoped=true"
import script from "./ModalWidgetClone.vue?vue&type=script&lang=js"
export * from "./ModalWidgetClone.vue?vue&type=script&lang=js"
import style0 from "./ModalWidgetClone.vue?vue&type=style&index=0&id=c8fc797e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fc797e",
  null
  
)

export default component.exports